var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1937_4301)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.493164,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1937_4301)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_1937_4301)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_1937_4301)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_1937_4301)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4453 22.4932L25.112 25.9932L22.0009 28.4932M25.8897 28.4932H29.0009",
    stroke: "#D73F47",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6822 17.0989L17.9906 21.0116C17.3772 21.3703 17.0001 22.0275 17.0001 22.7381V30.0622C17.0001 30.8323 17.4423 31.534 18.137 31.8663L24.8323 35.0694C25.391 35.3367 26.0419 35.3301 26.595 35.0515L32.8997 31.8766C33.5744 31.5368 34.0001 30.8458 34.0001 30.0903V22.7082C34.0001 22.0137 33.6399 21.369 33.0485 21.005L26.74 17.1222C26.111 16.735 25.3198 16.7261 24.6822 17.0989Z",
    stroke: "#D73F47",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1937_4301",
    x: -7.9,
    y: -7.40684,
    width: 65.8,
    height: 65.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1937_4301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1937_4301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_4301",
    x1: -20,
    y1: -30.5369,
    x2: 75.8258,
    y2: 8.56886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1937_4301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.6228 5.60829) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1937_4301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6381 33.9561) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1937_4301",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.21518e-06 -25.5068) rotate(38.2701) scale(56.6765 40.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBashIcon);
export default __webpack_public_path__ + "static/media/bash_icon.6bdefee048c085c39db1226d907e8bfc.svg";
export { ForwardRef as ReactComponent };